import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import './LeadCaptureModal.css';

interface LeadCaptureModalProps {
  isOpen: boolean;
  onClose: () => void;
  productName: string;
  whatsappMessage: string;
}

export const LeadCaptureModal: React.FC<LeadCaptureModalProps> = ({ isOpen, onClose, productName, whatsappMessage }) => {
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem('lukos_lead_data');
    return saved ? JSON.parse(saved) : { name: '', phone: '', company: '' };
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Persist data for future use
    localStorage.setItem('lukos_lead_data', JSON.stringify(formData));

    const finalMessage = `Olá! Meu nome é ${formData.name} do posto ${formData.company}. Gostaria de mais informações sobre o serviço de ${productName}.`;
    const encodedMessage = encodeURIComponent(finalMessage);
    
    window.open(`https://wa.me/5511978747233?text=${encodedMessage}`, '_blank');
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="lcm-overlay">
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="lcm-modal"
          >
            <button className="lcm-close" onClick={onClose}><X size={20} /></button>
            <h3 className="lcm-title">Fale com um Especialista</h3>
            <p className="lcm-subtitle">Preencha os dados abaixo para receber um atendimento personalizado sobre <strong>{productName}</strong>.</p>
            
            <form onSubmit={handleSubmit} className="lcm-form">
              <div className="lcm-input-group">
                <label>Nome Completo</label>
                <input type="text" required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="Seu nome" />
              </div>
              <div className="lcm-input-group">
                <label>WhatsApp</label>
                <input type="tel" required value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} placeholder="(11) 99999-9999" />
              </div>
              <div className="lcm-input-group">
                <label>Nome do Posto/Empresa</label>
                <input type="text" required value={formData.company} onChange={e => setFormData({...formData, company: e.target.value})} placeholder="Auto Posto Exemplo" />
              </div>
              
              <button type="submit" className="lcm-submit-btn">
                Ir para o WhatsApp <Send size={16} />
              </button>
            </form>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
